export default __webpack_public_path__ + "static/media/E-commerceRealCase2-moblie-en.991721f1.jpg";